<script lang="ts" setup>

</script>

<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.608398" width="16" height="16" rx="8" fill="#9146FF"/>
    <path d="M10.1786 9.1913L9.02518 10.2614H7.87177L6.86253 11.1978V10.2614H5.56494V6.24847H10.1786V9.1913Z" fill="#9146FF"/>
    <path d="M6.1743 5.13013L5.82647 5.47795L5.21777 9.391L7.04386 10.3475L7.30473 10.6953L9.04386 10.0866L10.9569 8.60839L11.0439 7.21708L10.9569 5.21708L10.696 5.13013H6.1743Z" fill="white"/>
    <path d="M5.96423 4.85596L4.52246 6.19361V11.0091H6.25258V12.3468L7.69435 11.0091H8.84776L11.4429 8.60137V4.85596H5.96423ZM10.8662 8.33384L9.71282 9.40396H8.55941L7.55017 10.3403V9.40396H6.25258V5.39102H10.8662V8.33384Z" fill="#202229"/>
    <path d="M10.001 6.32739H9.42432V7.93257H10.001V6.32739Z" fill="#202229"/>
    <path d="M8.41557 6.32739H7.83887V7.93257H8.41557V6.32739Z" fill="#202229"/>
  </svg>
</template>